import React from 'react';

const ProcessRefundIcon = () => (
  <>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.3223 6.46405L11.3226 6.46478C11.7363 7.78859 11.4177 9.19032 10.4229 10.3411C10.6102 9.76365 10.6032 9.15237 10.357 8.5504L10.357 8.55039L10.3559 8.54783C9.80659 7.22605 8.30386 6.44618 6.65743 6.44618H6.15743V6.94618V8.7908L0.707393 4.87168L6.15743 0.928058V2.78464V3.27614L6.64886 3.28456C8.91948 3.32349 10.7515 4.62736 11.3223 6.46405Z" stroke="#AF202D" />
    </svg>
  </>

);

export default ProcessRefundIcon;
